import NBType, { InferType } from '@netbase/nb-type'
import MetricTimeUnit from '../enums/MetricTimeUnit'

const AggregateResultSchema = NBType.object().shape('AggregateResultSchema', {
  /* @prop */
  labels: NBType.array().of(NBType.string()),
  /* @prop */
  timeUnit: NBType.enum(MetricTimeUnit),
  /* @prop */
  values: NBType.array().of(NBType.string())
  /* END */
})
export default AggregateResultSchema
export type AggregateResult = InferType<typeof AggregateResultSchema>
// RESERVE BELOW
